import { component } from 'picoapp'
import Plyr from 'plyr'

export default component(({node}) => {
  console.log('hey video stuff', node)
  const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen']
  const video = node.querySelector('.js-single-video')
  const videoBlock = node.querySelector('.js-video')
  const videoPlayer = new Plyr(video, {
    autopause: true,
    vimeo: {
      controls: false,
      autoplay: false
    },
    controls: controls
  })
  videoBlock.addEventListener('click', () => {
    node.classList.add('video-active')
    videoPlayer.play()
  })
})
